module.exports = __webpack_public_path__ + "static/media/twitterBig.f57a3a20.png";